import { CustomerOrderBase } from '../../../contracts/customer-order.js';
import { IOrderSideEffectResult } from './order-side-effect-processor.js';

export class OrderSideEffectContext {
  private readonly dataStore: Map<string, IOrderSideEffectResult> = new Map();

  constructor(
    public readonly order: CustomerOrderBase,
  ) {}

  setData(key: string, value: IOrderSideEffectResult): void {
    this.dataStore.set(key, value);
  }

  getData(key: string): IOrderSideEffectResult | undefined {
    return this.dataStore.get(key);
  }

  getDataAs<T extends IOrderSideEffectResult>(key: string, test: (v: IOrderSideEffectResult) => v is T): T | undefined {
    const rawValue = this.dataStore.get(key);
    if(rawValue == null) {
      return undefined;
    }

    if(!test(rawValue)) {
      return undefined;
    }

    return rawValue;
  }
}
